import {HarKV} from './harKV';
import {HarResponseContent} from './harResponseContent';
import {HttpResponse} from '@angular/common/http';

export class HarResponse {
    httpVersion: string;
    status: number;
    statusText: string;
    headers: HarKV[];
    cookies: HarKV[];
    content: HarResponseContent;

    constructor(response: HttpResponse<any>, mimeType: string) {
      this.httpVersion = 'http/2';
      this.status = response.status;
      this.statusText = response.statusText;

      // Headers
      this.headers = [];
      for (const header of response.headers.keys()) {
        const newHeader = new HarKV(header, response.headers.get(header).toString());
        this.headers.push(newHeader);
      }

      // Cookies
      this.cookies = [];

      // Query String
      this.content = new HarResponseContent();
      this.content.mimeType = mimeType;
      this.content = response.body;
    }
}
